import MessageBus from '@restore/messagebus';
import { MixPanelEvent, getEventName } from './types';
import mixpanel from 'mixpanel-browser';

const MESSAGE_BUS_DEBUG = import.meta.env.VITE_MESSAGE_BUS_DEBUG
  ? import.meta.env.VITE_MESSAGE_BUS_DEBUG === 'true'
  : false;

class MixPanelMessageBusAdapter {
  messageBus: MessageBus;
  constructor() {
    this.messageBus = new MessageBus(MESSAGE_BUS_DEBUG);
    this.messageBus.subscribe('mixpanel', (payload) => this.handleMixPanelEvent(payload as MixPanelEvent));
  }

  handleMixPanelEvent = (payload: MixPanelEvent): void => {
    mixpanel.track(getEventName(payload), payload);
  };
  unsubscribe = (): void => {
    this.messageBus.unsubscribe('mixpanel');
  };
}

export default MixPanelMessageBusAdapter;
